import { ReactElement } from 'react';

import { DemandWidget, demandWidgetPermissions } from 'widgets/DemandWidget';
import { UserOverviewWidget, usersWidgetPermissions } from 'widgets/UserOverviewWidget';

import { WidgetManager } from 'features/WidgetManager';

function DashboardPage(): ReactElement {
  const items = [
    {
      key: 'user-overview',
      content: <UserOverviewWidget />,
      requiredPermissions: usersWidgetPermissions,
    },
    {
      key: 'demand',
      content: <DemandWidget />,
      requiredPermissions: demandWidgetPermissions,
    },
  ];
  return <WidgetManager items={items} />;
}

export default DashboardPage;
